let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lor0a")).then(() => parcelRequire('hbVwU'));